// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3k6uH","label":"styles_label__3iwEX"};